import(/* webpackMode: "eager" */ "/home/fivestars/src/app/[[...main]]/page.tsx");
